import { NavLink } from "react-router-dom";
import TypeWriter from "../../components/TypeWriter";

export default function HeroSection() {
  return (
    <section
      id="heroSection"
      className="w-full flex flex-col items-center justify-center px-6 pt-20 pb-10"
    >
      {/* Title */}
      <div className="text-center max-w-3xl">
        <p className="text-2xl md:text-3xl text-light-purple font-medium">
          Hi! I’m
        </p>

        <h2 className="text-5xl md:text-7xl font-extrabold leading-tight">
          <span className="bg-gradient-to-r from-[#3B3355] to-blue-300 bg-clip-text text-transparent">
            Sarah Jacob
          </span>
        </h2>

        <div className="text-center max-w-3xl">
          <div className="text-2xl md:text-3xl text-light-purple font-medium">
            <TypeWriter />
          </div>
        </div>
        
        <p className="mt-6 text-base md:text-lg text-gray-600">
          Click the drawings to see what I’ve been up to or{" "}
          <NavLink
            to="/about"
            className="underline underline-offset-4 hover:opacity-80"
          >
            click here
          </NavLink>
        </p>
      </div>

      {/* 3 Cards */}
      <div className="mt-12 w-full max-w-6xl grid grid-cols-1 md:grid-cols-3 gap-10 items-end">
        {/* Developer */}
        <NavLink
          to="/dev"
          className="group flex flex-col items-center text-center"
        >
          <img
            src={`${process.env.PUBLIC_URL}/img/developer.png`}
            alt="Developer"
            className="w-[260px] md:w-[280px] h-auto group-hover:scale-[1.02] transition"
          />
          <span className="mt-4 px-4 py-2 rounded-md bg-white shadow-sm border border-black/10 font-semibold tracking-wide text-[#3B3355]">
            DEVELOPER
          </span>
        </NavLink>

        {/* Researcher / Publications */}
        <NavLink
          to="/research"
          className="group flex flex-col items-center text-center"
        >
          <img
            src={`${process.env.PUBLIC_URL}/img/researcher.png`}
            alt="Researcher"
            className="w-[260px] md:w-[280px] h-auto group-hover:scale-[1.02] transition"
          />
          <span className="mt-4 px-4 py-2 rounded-md bg-white shadow-sm border border-black/10 font-semibold tracking-wide text-[#3B3355]">
            RESEARCHER
          </span>
        </NavLink>

        {/* Artist */}
        <NavLink
          to="/art"
          className="group flex flex-col items-center text-center"
        >
          <img
            src={`${process.env.PUBLIC_URL}/img/artist.png`}
            alt="Artist"
            className="w-[260px] md:w-[280px] h-auto group-hover:scale-[1.02] transition"
          />
          <span className="mt-4 px-4 py-2 rounded-md bg-white shadow-sm border border-black/10 font-semibold tracking-wide text-[#3B3355]">
            ARTIST
          </span>
        </NavLink>
      </div>
    </section>
  );
}
